import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useAuthManager } from '../../components/Auth/AuthManager'
import { useTheme } from '../../context/ThemeContext'
import { ThemeModal } from '../../components/Modals/ThemeModal'
import { SunIcon, MoonIcon } from '../../components/shared/icons'
import styles from './LandingNav.module.css'

export function LandingNav({ minimal }: { minimal?: boolean }) {
  const { user } = useAuth()
  const { openSignIn, openSignUp } = useAuthManager()
  const { theme } = useTheme()
  const navigate = useNavigate()
  const [menuOpen, setMenuOpen] = useState(false)
  const [themeModalOpen, setThemeModalOpen] = useState(false)

  const scrollTo = (id: string) => {
    setMenuOpen(false)
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <nav className={styles.nav}>
      <div className={styles.inner}>
        <a href='/welcome' className={styles.logo}>
          FC0
        </a>

        {!minimal && (
          <button
            className={styles.hamburger}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label='Toggle menu'
          >
            <span />
            <span />
            <span />
          </button>
        )}

        <div className={`${styles.menu} ${menuOpen && !minimal ? styles.menuOpen : ''}`}>
          {!minimal && (
            <div className={styles.links}>
              <button
                className={styles.navLink}
                onClick={() => scrollTo('features')}
              >
                Features
              </button>
              <button
                className={styles.navLink}
                onClick={() => scrollTo('about')}
              >
                About
              </button>
              <button
                className={styles.navLink}
                onClick={() => scrollTo('showcase')}
              >
                Games
              </button>
              {/* <button className={styles.navLink} onClick={() => scrollTo('how-it-works')}>How It Works</button> */}
              <button
                className={styles.navLink}
                onClick={() => scrollTo('community')}
              >
                Community
              </button>
              <Link to='/docs' className={styles.navLink}>
                Documentation
              </Link>
            </div>
          )}

          <div className={styles.actions}>
            <button
              className={styles.themeToggle}
              onClick={() => setThemeModalOpen(true)}
              title='Change theme'
            >
              {theme.isDark ? <SunIcon /> : <MoonIcon />}
            </button>
            {!user && (
              <>
                <button className='btn btn-ghost' onClick={openSignIn}>
                  Log In
                </button>
                <button className='btn btn-ghost' onClick={openSignUp}>
                  Sign Up
                </button>
              </>
            )}
            <button
              className='btn btn-primary'
              onClick={() => navigate('/', { state: { direct: true } })}
            >
              Go to Editor
            </button>
          </div>
        </div>
      </div>
      <ThemeModal
        isOpen={themeModalOpen}
        onClose={() => setThemeModalOpen(false)}
      />
    </nav>
  )
}
